import * as React from "react";
import { forwardRef } from "react";
const TrafficConeIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12.492 3.388a1.11 1.11 0 0 1 1.069.81l3.881 13.815h.639a1.51 1.51 0 0 1 1.51 1.51v1.013a1.51 1.51 0 0 1-1.51 1.511H5.92a1.51 1.51 0 0 1-1.51-1.511v-1.013a1.51 1.51 0 0 1 1.51-1.51h.588l3.886-13.816.029-.088a1.11 1.11 0 0 1 1.04-.721h1.03zM5.917 19.514l-.006.006v1.019l.001.001 12.169.006.01-.008V19.518l-.007-.006H5.916zm2.15-1.501h7.816l-.666-2.37H8.733l-.666 2.37zm1.088-3.87h5.641l-.514-1.83H9.67l-.515 1.83zm.937-3.33h3.769l-.514-1.83h-2.741l-.514 1.83zm.936-3.33h1.898l-.729-2.595h-.439l-.73 2.595z"
}));
const ForwardRef = forwardRef(TrafficConeIcon);
export default ForwardRef;